<!--
Considera pedidos de venda válidos (aberto ou faturado) agrupado por usuario
Considera as metas de venda


-->


<template>
  <div class="container-full-width default-container p-3">
    <filtro
        :showfiltro="showfiltro"
        :params="paramsFiltro" 
        @change="filtroChange"
        @cancel="handleCloseFiltro"
    />

    <div class="row">
      <div class="col-12">
        <span class="lbl-deal-title mb-2 w-100">PERFORMANCE DE VENDAS POR VENDEDOR</span>
        <v-button label="Metas de Venda" class="float-right" @click="clickMetas"></v-button>
        <v-button label="Retornar para visões" icon="fa-bar-chart" class="float-right" @click="clickRetornar"></v-button>
      </div>
    </div>
    <hr>
    <div class="row mb-3 align-items-center">
        <div class="col-md-auto">
            <div class="d-flex align-items-center">
                <span class="lbl-edit">Período</span>
                <input-month :p-month="filter" :show-options="false" @monthChange="handleMonthChange"></input-month>
                <!-- <form-field ref="data" v-model="data_referencia" type="date" col="12" label="Referência"></form-field> -->
            </div>
        </div>
    </div>

    <div class="row" v-if="chartValues.length > 0">
      <div class="col-md-3 col-12 p-3">
        <span class="lbl-title mb-2">Resumo do Mês</span>
        <div class="p-4" style="border-top: 1px solid #dee2e6 !important; background: #fafafa">
            <!-- <span class="lbl-edit mb-5">Resumo do mês</span> -->
            <div class="resumo__performance mb-2">
                <span class="lbl-data mr-2">Vendido no mês</span>
                <span class="resumo__performance__value">{{ dadosGrafico.vendido_mes | formatValue(2) }}</span>
            </div>
            <div class="resumo__performance mb-4">
                <span class="lbl-data mr-2">Vendido hoje</span>
                <span class="resumo__performance__value">{{ dadosGrafico.vendido_hoje | formatValue(2) }}</span>
            </div>
            <div class="resumo__performance mb-4">
                <span class="lbl-data mr-2">Vendido no mês anterior</span>
                <span class="resumo__performance__value">{{ dadosGrafico.vendido_mes_anterior | formatValue(2) }}</span>
            </div>

            <div class="resumo__performance mb-4">
                <span class="lbl-data mr-2">Meta</span>
                <span class="resumo__performance__value" v-if="dadosGrafico.meta_mes">{{ dadosGrafico.meta_mes | formatValue(2) }}</span>
                <span class="resumo__performance__value" v-else>Não definida</span>
            </div>
            <div class="resumo__performance mb-4" v-if="dadosGrafico.objetivo_dia">
                <span class="lbl-data mr-2">Objetivo Diário</span>
                <span class="resumo__performance__value">{{ dadosGrafico.objetivo_dia | formatValue(2) }}</span>
            </div>
        </div>
      </div>
      <div class="col-md-9 col-12 p-3">
        <div class="lbl-title mb-2">Gráfico</div>
        <div class="" style="border-top: 1px solid #dee2e6 !important">
          <chart :params="paramsChart"></chart>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12 lbl-title mb-2">
        USUÁRIOS/VENDEDORES
        <v-button label="Excel" class="float-right" @click="loadData(true)"></v-button>
        <!-- <v-button label="Imprimr" class="float-right"></v-button> -->
      </div>
    </div>

    <div class="row mb-5">
      <div class="col-12">
        <div style="width: 100%; max-height: 100%; overflow: hidden; font-size: 12px">
          <div style="overflow: auto">
            <table class="table table-striped table-hover responsive tablesorter w-100">
                <thead>
                    <tr>
                      <template v-for="col in colunas">
                        <th v-if="col.visible" :class="col.class" :style="col.style">{{ col.label }}</th>
                      </template>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(row, index) in usuarios" :key="index">
                        <td v-if="colunas[0].visible" class=""  title="Visualizar este usuário"> 
                          <a v-if="!filtroUsuario" :href="'#/consultas/vendas-vendedor?usuario=' + row.id + '&datareferencia=' + data_referencia">{{ row.nome_usuario }} <i class="fa fa-search" aria-hidden="true"></i></a>
                          <span v-else>{{ row.nome_usuario }}</span>
                        </td>
                        <td v-if="colunas[1].visible" class="">{{ row.posicao }}</td>
                        <td v-if="colunas[2].visible" class="numerico">{{ row.meta_valor | formatValue(2) }}</td>
                        <td v-if="colunas[3].visible" class="numerico">{{ row.valor | formatValue(2) }}</td>
                        <td v-if="colunas[4].visible" class="numerico">{{ row.meta_percentual | formatValue(2) }}%</td>
                        <td v-if="colunas[5].visible" class="numerico">{{ row.orcamentos_valor | formatValue(2) }}</td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr>
                        <th class="total">Total</th>
                        <th class="numerico total">{{ dados.total.meta_valor | formatValue(2) }}</th>
                        <th class="numerico total">{{ dados.total.valor | formatValue(2) }}</th>
                        <th class="total"></th>
                        <th class="numerico total">{{ dados.total.orcamentos_valor | formatValue(2) }}</th>
                    </tr>
                </tfoot>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DashCard from "../dashboards/dash-card";
import Chart from "./chart";
import Filtro from "./filtro";
import { apiORDSpost } from "../shared/api-functions";
import { apiDownload2 } from "../shared/api-functions";

export default {
  components: {
    DashCard,
    Filtro,
    Chart,
  },

  data() {
    return {
      showfiltro: false,

      dados: {},
      dadosGrafico: null,

      data_referencia: null,
      filter: {            //objeto utilizado pelo filtro de mes
          startDate: null,
          endDate: null,
      },

      filtroUsuario: false,

      filtro: {
      },

      colunas: [
      ],

      mounting: false,

    };
  },

  computed: {
    colors: function () {
      //valor vendido, meta, mes anterior
      let color = '#d41b1b'
      if (this.dados.vendido_mes >= this.dados.meta_mes)
        color = '#0d904f'
      return  [color, '#1a73e8', '#ffff00', '#5dade2']
    },

    usuarios: function () {
      if (!this.dados.usuarios) 
        return []
      else 
        return this.dados.usuarios
    },

    paramsChart: function () {
      return { chart: { type: "LineChart" }, values: this.chartValues, colors: this.colors }
    },

    chartValues: function () {
      if (!this.dadosGrafico || this.dadosGrafico.grafico.length == 0)
        return []
      else
        return this.dadosGrafico.grafico
    },
    
  },

  watch: {
      data_referencia: function () {
          this.loadData()
      },
  },

  methods: {
    handleCloseFiltro(){
            this.showfiltro = false
        },
    clickMetas () {
      this.$router.push('/metas')
    },

    clickRetornar () {
      this.$router.push('/')
    },

    montaColunas () {
        this.colunas = [
            { nome: 'nome', visible: true, label: 'Nome do Usuário', sortable: true, orderby: null, class: '', style: 'min-width: 200px;' },
            { nome: 'posicao', visible: false, label: 'Posição', sortable: true, orderby: null, class: 'numerico size130', style: '' },
            { nome: 'meta_valor', visible: true, label: 'Meta', sortable: true, orderby: null, class: 'numerico size130', style: '' },
            { nome: 'valor', visible: true, label: 'Valor Vendido', sortable: true, orderby: null, class: 'numerico size130', style: '' },
            { nome: 'meta_percentual', visible: true, label: '% Atingido', sortable: true, orderby: null, class: 'numerico size130', style: '' },
            { nome: 'orcamentos_valor', visible: true, label: 'Valor de Orçamentos Abertos', sortable: true, orderby: null, class: 'numerico size130', style: '' },
        ]
    },

    handleShowFiltro() {
      this.showfiltro = true;
    },

    handleMonthChange (data) {
        this.filter.endDate = this.$lastDay(this.$addMonths(this.filter.startDate, 11))
        this.data_referencia = this.filter.startDate

        this.$router.push({path:'/consultas/vendas-vendedor', query: {datareferencia: this.data_referencia}});

        //this.loadData()
    },

    filtroChange(filtro) {
      this.showfiltro = false;

      this.filtro = filtro;

      this.loadData();
    },

    async loadData(excel) {
      
      let url = "consulta/vendas/vendasusuario";

      this.filtro.excel = excel
      this.filtro.data_referencia = this.data_referencia
      // this.filtro.resumo = false

      if (excel) 
        apiDownload2(this, url, this.filtro, "post")
      else {
        const data = await apiORDSpost(this.$store, url, this.filtro, "post")
        if (data) {
          this.dados = data;
        } else {
          this.dados = {};
        }
        this.montaColunas()

        url = "consulta/vendas/graficoevolucaovendas";
        const grafico = await apiORDSpost(this.$store, url, this.filtro, "post")
        if (grafico) {
          this.dadosGrafico = grafico;
        } else {
          this.dadosGrafico = {};
        }

      }
    },
  },

  mounted() {

  },

  created() {
    // this.data_referencia = "2020-06-01"
    
    this.filter.startDate = this.$firstDay(this.$getDate())
    this.filter.endDate = this.$lastDay(this.$getDate())
    this.data_referencia = this.filter.startDate 

    if (this.$route.query.usuario) {
      this.filtro.usuario = [this.$route.query.usuario]
      this.filtroUsuario = true
    }

    if (this.$route.query.datareferencia) {
      this.filter.startDate = this.$firstDay(this.$route.query.datareferencia)
      this.filter.endDate = this.$lastDay(this.$route.query.datareferencia)
      this.data_referencia = this.filter.startDate 
    }
    
    this.loadData()
  },
}


</script>

<style>

table .numerico {
  min-width: 65px;
  text-align: right;
}

table .size130 {
  min-width: 130px;
}

table .total {
    background: #c1c4c7;
    border: none;
}

table .var {
    min-width: 85px;
    text-align: center;
    background: #c1c4c7;
    display: inline-block;
}

table .var-negative {
    color: white;
    background: indianred;
}

table .var-positive {
    color: white;
    background: green;
}

table .border-left {
  border-left: 1px solid #dee2e6;
}

.resumo__performance {
  display: flex;
  align-items: center;
  justify-content: space-between;  
}

.resumo__performance__value {
    padding: 5px 15px;
    font-size: 18px;
    font-weight: 600;
    text-align: left;
    border-radius: 10%;
}

</style>



// WEBPACK FOOTER //
// src/consultas/consulta-vendas-vendedor.vue